import React from "react";
import EmployeeDocumentTabs from "./EmployeeDocumentTabs";
import { PCard } from "components/Ui/styled";

const EmployeeDocumentsComponent = () => {
  return (
    <>
      <EmployeeDocumentTabs />
    </>
  );
};

export default EmployeeDocumentsComponent;
